import { getDomain } from 'helpers/resourcePath';

// DOMAIN is runtime-overridable (see config/env.js), so it must be read through getRuntimeEnv:
// the build-time process.env value is only a fallback and is baked to /entando-de-app, which
// breaks every admin-console link when the app is deployed on the root context.
export const adminConsoleUrl = url => `${getDomain()}/${url}`;

export const generateMfeRoutes = mfe => mfe.reduce((acc, curr) => {
  if (curr.descriptorExt && curr.descriptorExt.paths) {
    const routes = [];
    curr.descriptorExt.paths.forEach((route) => {
      const path = route.split('/').filter(Boolean).join('/');
      const mfeRoute = [curr.bundleCode, path].join('/');
      const id = curr.id || `id-${curr.bundleGroup}-${curr.bundleCode}-${route}-${curr.widgetCode}`;
      const refactoredId = id.replace(/\s+/g, '-');
      routes.push({ route: `/${mfeRoute}`, id: refactoredId });
    });
    return [...acc, ...routes];
  }
  return acc;
}, []);
